// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../channels2022/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".btn[data-v-68af433f]{display:flex;align-items:center;justify-content:center;padding-top:.375rem;padding-bottom:.375rem;min-width:auto;height:40px}.btn.square[data-v-68af433f]{flex:40px 0 0;width:40px;height:40px;padding:0}.btn[data-v-68af433f]:disabled{opacity:1}.gap-2[data-v-68af433f]{gap:.5rem}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
